import React, { useEffect, useState, useContext } from 'react'
import './cancelledmeetings.css'
import { AiOutlineDelete } from "react-icons/ai";
import { DELETE, POST } from '../../../../Common/HttpMethods/HttpMethods';
import { Url } from '../../../../../constants/ApiUrlConstants';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { contextData } from '../../../../../context/ContextProvider';
import FailModal from '../../../../Common/Popups/FailModal';
import SuccessModal from '../../../../Common/Popups/SuccessModal';
import { MdSchedule } from "react-icons/md";
import { BsEye } from "react-icons/bs";
import Modal from "react-modal";
import CancelledMeetingCard from './CancelMeetingCard';
import { CanceledBy, Cuurent_EMAIL, Cuurent_RBAC_roles, Cuurent_USERNAME, stripHtmlTags } from '../../../../CommonCase/CommonFunctions';
import CancelledMeetingModal from '../../../../CommonCase/CancelledMeetingModal';
export const handleCancelFVModalClose = (
  setCancelMeetOpenView,
  setAgendaDivHeight,
  setMsgDivHeight
) => {
  setCancelMeetOpenView(false);
  setAgendaDivHeight(false);
  setMsgDivHeight(false);
};

export const handleSessionExpClose = (navigate, setActive) => {
  sessionStorage.clear();
  navigate('/login');
  setActive('tab1');
}

export const handleCloseFailModel = (setOpenFailModal) => {
  setOpenFailModal(false);
}

export const handleEdit = (id, navigate) => {
  navigate("/main/meetings/setupmeeting", { state: { meetingId: id, flow: "CancelledMeetings", cancelledMeetingEdit: true } })
}

export const handleDelete = async ({
  setOpenDeleteModal,
  setLoading,
  DELETE,
  Url,
  idToDelete,
  token,
  setSuccessMessage,
  setOpenSuccessModal,
  toggleForCount,
  setToggleForCount,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
}) => {
  try {
    setOpenDeleteModal(false);
    setLoading(true);

    const deleteMeetingResp = await DELETE(
      Url.deleteMeeting.replace("{mid}", `${idToDelete}`),
      token
    );

    if (deleteMeetingResp.SUCCESS) {
      setLoading(false);
      setSuccessMessage("Meeting deleted successfully.");
      setOpenSuccessModal(true);
      setToggleForCount(!toggleForCount);
    } else if (deleteMeetingResp.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteMeetingResp.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteMeetingResp.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteMeetingResp.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (deleteMeetingResp.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else {
      setLoading(false);
      setFailMessage("Failed to delete meeting");
      setOpenFailModal(true);
    }
  } catch (error) {
    setLoading(false);
    setFailMessage("Failed to delete meeting");
    setOpenFailModal(true);
  }
};

export const getDashboardData = async ({
  selectedFromDate,
  selectedToDate,
  POST,
  Url,
  token,
  setLoading,
  setData,
  setDataCopy,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
}) => {
  const allMeetingsBody = {
    fromDate: moment(selectedFromDate).format('YYYY-MM-DD'),
    toDate: moment(selectedToDate).format('YYYY-MM-DD'),
    meetType: "Cancelled"
  };

  try {
    setLoading(true);

    const cancelledMeetingsResp = await POST(Url.getAllTypeOfMeetingWithCount, token, allMeetingsBody);

    if (cancelledMeetingsResp.SUCCESS) {
      const data = cancelledMeetingsResp?.DATA?.cancelledMeeting?.map(i => ({
        ...i,
        viewMore: false
      }));
      setData(data);
      setDataCopy(data);
      setLoading(false);
    } else if (cancelledMeetingsResp.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (cancelledMeetingsResp.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (cancelledMeetingsResp.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (cancelledMeetingsResp.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (cancelledMeetingsResp.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else {
      setLoading(false);
      setOpenFailModal(true);
      setFailMessage("Failed to fetch meetings.");
    }
  } catch (error) {
    setLoading(false);
    setOpenFailModal(true);
    setFailMessage("Failed to fetch meetings.");
  }
};


export function isOverflowing(element) {
  return element?.scrollHeight > element?.clientHeight || element?.scrollWidth > element?.clientWidth;
}

export function handleOverflowCheck(setAgendaDivHeight, setMsgDivHeight) {
  const div = document.getElementById("agenda_div");
  const isAgendaOverflowing = isOverflowing(div);

  const div2 = document.getElementById("message_div");
  const isMessageOverflowing = isOverflowing(div2);

  if (isAgendaOverflowing) {
    setAgendaDivHeight(isAgendaOverflowing);
  }

  if (isMessageOverflowing) {
    setMsgDivHeight(isMessageOverflowing);
  }
}


const CancelledMeetings = ({ selectedToDate, searchInp, selectedFromDate, toggleForCount, setToggleForCount }) => {
  const { setLoading, setActive } = useContext(contextData);

  const [data, setData] = useState();
  const [dataCopy, setDataCopy] = useState();

  const navigate = useNavigate();
  // ---------------------------------------------------------------------------Popup Utility----------------------------------------------------------------------
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [openFailModal, setOpenFailModal] = useState(false);
  const [failMessage, setFailMessage] = useState("");
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false)
  const [cancelMeetOpenView, setCancelMeetOpenView] = useState(false)

  // rbac roles
  let rrbac = Cuurent_RBAC_roles();
  const username = Cuurent_USERNAME();
  let Email = Cuurent_EMAIL();
  let token = sessionStorage.getItem('TOKEN')

  const storedRbacRoles = JSON.parse(rrbac);
  const userRole = sessionStorage.getItem("USER")

  const [rbac, setRbac] = useState({});

  useEffect(() => {
    if (userRole !== "USER") {
      const roleWithQMSDashboard = storedRbacRoles?.find(role => role.useCase === "QMS Cancelled Meetings");
      if (roleWithQMSDashboard) {
        setRbac(roleWithQMSDashboard);
      }
    }
  }, []);



  const [openDeleteModal, setOpenDeleteModal] = useState(false);



  const [idToDelete, setIdToDelete] = useState()

  const [fullView, setFullView] = useState({
    isClicked: false,
    viewMore: false,
    data: {
      title: "",
      date: "",
      time: "",
      attendees: [],
      agenda: [],
      startTime: "",
      endTime: ""
    }
  });

  const [agendaDivHeight, setAgendaDivHeight] = useState(false);
  const [msgDivHeight, setMsgDivHeight] = useState(false);


  useEffect(() => {
    setTimeout(() => {
      handleOverflowCheck(setAgendaDivHeight, setMsgDivHeight);
    }, 1000);
  }, [fullView]);


  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  const handleOpenFullView = (meeetingData) => {
    setCancelMeetOpenView(true)
    const { meetingSubject, startTime, endTime, emailDetails, meetingAgenda, cancelReason, cancelledByName } = meeetingData;
    const data = {
      attendees: (emailDetails && emailDetails[0]?.attendees) ? emailDetails[0].attendees.split(";").map(item => item.trim()) : [],
      agenda: !meetingAgenda ? [] : [...meetingAgenda?.split("\n")],
      title: !meetingSubject ? "" : meetingSubject,
      date: meeetingData?.parseStartDate,
      startTime: startTime,
      endTime: endTime,
      cancelReason: cancelReason,
      cancelledByName: cancelledByName

    }


    setFullView((prevState) => ({ viewMore: false, isClicked: false, data }));
    setLoading(true);
    setTimeout(() => {
      setLoading(false)
    }, 1100);
  }

  // --------------------------------------------------------------------------Popup End--------------------------------------------------------------------------

  useEffect(() => {
    getDashboardData({
      selectedFromDate,
      selectedToDate,
      POST,
      Url,
      token,
      setLoading,
      setData,
      setDataCopy,
      setSessionExpiredModal,
      setFailMessage,
      setOpenFailModal,
    })
  }, [selectedFromDate, selectedToDate])

  useEffect(() => {
    handleSearch(searchInp)
  }, [searchInp])


  const handleSearch = (inp) => {

    setData(dataCopy?.filter((i) => {
      return i?.meetingSubject?.toLowerCase().includes(inp?.toLowerCase())
    })
    )
  }

  const commonStyles = {
    boxShadow: "0px 0px 3px #00000029"
  };

  return (
    <>
      {data?.length == 0 ? (
        <div className="empty-card">
          No Records to show
        </div>
      ) :
        <div className='cancelled-meeting-main'>
          {
            data?.map((item) => {

              return (

                <CancelledMeetingCard
                  item={item}
                  commonStyles={commonStyles}
                  handleOpenFullView={handleOpenFullView}
                  handleEdit={handleEdit}
                  setFailMessage={setFailMessage}
                  setOpenDeleteModal={setOpenDeleteModal}
                  setIdToDelete={setIdToDelete}
                  rbac={rbac}
                  navigate={navigate}
                />

              )
            })
          }
          {/* ---------------------------------------------------------------------------------POPUPS------------------------------------------------------- */}


          <CancelledMeetingModal
            isOpen={cancelMeetOpenView}
            onRequestClose={() => handleCancelFVModalClose(setCancelMeetOpenView, setAgendaDivHeight, setMsgDivHeight)}
            customStyles={customStyles}
            fullView={fullView}
            setFullView={setFullView}
            agendaDivHeight={agendaDivHeight}
            extractTextFromHtml={stripHtmlTags}
            
          />


          <FailModal
            openFailModal={openFailModal}
            setOpenFailModal={setOpenFailModal}
            failMessage={failMessage}
            setFailMessage={setFailMessage}
            recallFunctionOnOk={() => handleCloseFailModel(setOpenFailModal)}
            recallFunctiononClose={() => handleCloseFailModel(setOpenFailModal)}
          />

          {/* //////////////POPUP for delete */}
          <FailModal
            openFailModal={openDeleteModal}
            setOpenFailModal={setOpenDeleteModal}
            failMessage={failMessage}
            setFailMessage={setFailMessage}
            recallFunctionOnOk={() =>
              handleDelete({
                setOpenDeleteModal,
                setLoading,
                DELETE,
                Url,
                idToDelete,
                token,
                setSuccessMessage,
                setOpenSuccessModal,
                toggleForCount,
                setToggleForCount,
                setSessionExpiredModal,
                setFailMessage,
                setOpenFailModal,
              })
            }
            recallFunctiononClose={() => handleCloseFailModel(setOpenFailModal)}
          />

          {/* session expire modal  */}
          <FailModal
            openFailModal={sessionExpiredModal}
            setOpenFailModal={setSessionExpiredModal}
            failMessage={failMessage}
            setFailMessage={setFailMessage}
            recallFunctionOnOk={() => handleSessionExpClose(navigate, setActive)}
            recallFunctiononClose={() => handleSessionExpClose(navigate, setActive)}
          />

          <SuccessModal
            openSuccessModal={openSuccessModal}
            setOpenSuccessModal={setOpenSuccessModal}
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
            recallFunctionOnOk={() =>
              getDashboardData({
                selectedFromDate,
                selectedToDate,
                POST,
                Url,
                token,
                setLoading,
                setData,
                setDataCopy,
                setSessionExpiredModal,
                setFailMessage,
                setOpenFailModal,
              })
            }
          />
        </div>
      }
    </>
  )
}

export default CancelledMeetings